<template>
  <div class="group-list">
    <el-table
      ref="multipleTable"
      :data="groupData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      class="common-edit-button"
    >
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        prop="crowdName"
        label="分组名字"
        :show-overflow-tooltip="true"
        width="200px"
      >
      </el-table-column>
      <el-table-column
        prop="crowdLeader"
        label="组长"
        :show-overflow-tooltip="true"
        width="200px"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        :show-overflow-tooltip="true"
        width="200px"
      >
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          {{ scope.row.status == "0" ? "正常" : "停用" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="185px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 修改 -->
            <el-button
              type="warning"
              icon="el-icon-edit"
              @click="editGroup(scope.row)"
              v-hasPermi="'sc:crowd:edit'"
              size="small"
            >修改
            </el-button>
            <!-- 删除 -->
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="delGroup(scope.row)"
              v-hasPermi="'sc:crowd:delete'"
              size="small"
            >删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 修改宿舍信息 -->
    <editGroupInfo
      :dialogFormVisible.sync="editShow"
      :groupInfo="groupInfo"
      :teacherList="teacherList"
      v-show="editShow"
      :groupTypeList="groupTypeList"
      :gradeSelectList="gradeSelectList"
      :courseList="courseList"
      @searchTeacher="searchTeacher"
    />
  </div>
</template>

<script>
import editGroupInfo from "../editgroup-info/editgroup-info.vue";
export default {
  data() {
    return {
      // selectList: [],
      groupInfo: null,
      editShow: false,
      editSelectList: [],
    };
  },
  props: {
    groupData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    groupTypeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    teacherList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    gradeSelectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    courseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    editGroupInfo,
  },
  inject: ["refresh"],
  created() {},
  methods: {
    searchTeacher(query) {
      this.$emit("searchTeacher", query);
    },
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      this.$emit("multiple", list);
    },
    // 修改宿舍
    editGroup(item) {
      // console.log(item);
      this.groupInfo = item;
      this.editShow = true;
    },
    // 删除宿舍
    delGroup(item) {
      this.$confirm("是否删除该分组?", "删除分组", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除学生信息接口
          let list = [];
          list.push(item.id);
          this.delete(this.$url.delTeacherGroup + "/" + list)
            .then((res) => {
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error("删除失败，请稍后重试");
              }
            })
            .catch((err) => {
              console.log(err);
              // this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
@import "./groupList.scss";
</style>
